<template>
  <el-card>
    <div slot="header" class="clearfix">
      <span>投入品管理</span>
      <el-button
        style="float: right"
        size="small"
        type="primary"
        icon="el-icon-plus"
        @click="$router.push(`inputs/newone`)"
      >
        新增投入品
      </el-button>
    </div>
    <el-row :gutter="20">
      <el-col :span="4">
        <!-- 左侧过滤搜索面板 -->
        <el-col>
          <el-form ref="form" :model="filter" label-position="top" size="small">
            <el-form-item label="类型">
              <el-radio-group v-model="filter.type">
                <el-radio-button label="所有">所有</el-radio-button>
                <el-radio-button label="化肥">化肥</el-radio-button>
                <el-radio-button label="农药">农药</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="名称">
              <el-input
                v-model="filter.name"
                placeholder="投入品名称"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="mini" @click="search"
                >搜索</el-button
              >
            </el-form-item>
          </el-form>
        </el-col>
      </el-col>
      <!-- 右侧列表显示 -->
      <el-col :span="20">
        <el-row :gutter="10" style="min-height: 580px">
          <!-- <el-empty
            v-show="tableData.length == 0"
            description="暂无投入品"
          ></el-empty> -->
         
        <el-table   v-show="tableData.length == 0">
        <div slot="empty" style="height:400px;line-height: 400px;">
          <i class="el-icon-warning-outline"></i>暂无投入品
        </div>
        </el-table>

          <el-col :span="4" v-for="(item, index) in tableData" :key="index">
            <el-card :body-style="{ padding: '0px' }">
              <img
                src="./default.jpg"
                alt="照片暂缺"
                style="width: 179px; display: block; background-color: #dff3ff"
              />
              <div style="padding: 8px">
                <h4 style="margin: 8px 0">
                  {{ item.name }}
                </h4>
                <p style="margin-top: 0; color: #999; font-size: 13px">
                  {{ item.packingWeight + item.unit }}
                </p>
                <p style="margin-top: 0; color: #999; font-size: 14px">
                  {{ item.manufacturer }}
                </p>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="编辑"
                  placement="top"
                >
                  <el-button
                    icon="el-icon-edit"
                    type="warning"
                    circle
                    size="large"
                    style="padding: 4px"
                    @click="editor(item.id)"
                  />
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="删除"
                  placement="top"
                >
                  <el-button
                    icon="el-icon-delete"
                    type="danger"
                    circle
                    size="large"
                    style="padding: 4px"
                    @click="deleteRow(item.id)"
                  />
                </el-tooltip>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <div style="margin-top: 12px; text-align: center">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-size="value"
            layout="prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import { getInputs, deleteInputs } from '@/api/inputs.js'
export default {
  name: 'input',
  // components: { PlantAdd },
  data() {
    return {
      pageNum: 1,
      value: 10,
      total: 0,
      searchContent: null,
      activate: '3-3',
      tableData: [],
      activeTab: 'newone',
      filter: {
        name: null,
        type: null,
      },
    }
  },
  methods: {
    search() {
      let option = {
        pageNum: this.pageNum,
        pageSize: this.value,
        name: this.filter.name,
        type: this.filter.type,
      }
      if (option.name == '') {
        option.name = null
      }
      if (option.type == '所有') {
        option.type = null
      }
      getInputs(option).then((data) => {
        console.log(data)
        this.tableData = data.data.list
        this.total = data.data.total
      })
    },
    inpuDatatGet() {
      getInputs({
        pageNum: this.pageNum,
        pageSize: this.value,
        name: this.filter.name,
        type: this.filter.type,
      }).then((data) => {
        console.log(data)
        this.tableData = data.data.list
        this.total = data.data.total
      })
    },
    searchlist() {
      this.pageNum = 1
      if (this.searchContent == '') {
        this.searchContent == null
        this.PlanDataGet()
      } else {
        this.PlanDataGet()
      }
    },
    editor(id) {
      this.$router.push(`inputs/` + id)
    },
    handleSizeChange(val) {
      this.value = val
      this.pageNum = 1
      this.PlanDataGet()
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.PlanDataGet()
      console.log(`当前页: ${val}`)
    },
    deleteRow(id) {
      deleteInputs(id).then((resp) => {
        console.log(resp)
        this.inpuDatatGet()
      })
    },
    showactivate(a) {
      console.log('a', a), (this.activate = a)
      //  (this.activate = a)
    },
  },
  mounted() {
    this.inpuDatatGet()
  },
  beforeDestroy() {},
}
</script>

<style scoped>
.employListbox {
  background: #fff;
  border: 1px solid #dcdfe6;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
  padding: 8px;
  min-height: 603px;
}
.cardTitle {
  margin-top: 0px;
  margin-bottom: 15px;
}
.image-product-item {
  height: 120px;
}
.input-Items-style {
  width: 18%;
  margin-right: 15px;
  margin-bottom: 15px;
}
</style>
<style>
.el-button + .el-button {
  margin-left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/resource/inputs/InputsAll.vue